import { logger } from '@gem/modules/logger';

import { buildModelError } from 'APP/model/error/errorBuilder';
import {
  registerPushTokenRequest,
  unregisterPushTokensRequest,
} from 'APP/wsApi/wsAppApi/requests/pushNotifications';
import { Platform } from 'APP/wsApi/wsAppApi/types/common/common_model_pb';

import { pushNotificationTokenTypeRequestMap } from './pushNotificationsModel.b2b.mapper';
import { PushNotificationTokenType } from './pushNotificationsModel.types';

export const registerPushNotifications = async (
  tokenType: PushNotificationTokenType,
  deviceToken: string
): Promise<void> => {
  try {
    await registerPushTokenRequest({
      tokenTypes: [pushNotificationTokenTypeRequestMap[tokenType]],
      deviceToken,
      platformType: Platform.WEB,
    });
  } catch (e) {
    logger.get('API').error('push.registerPushNotifications', e);
    throw buildModelError(e);
  }
};

export const unregisterPushNotifications = async (
  tokenType: PushNotificationTokenType,
  deviceToken: string
): Promise<void> => {
  try {
    await unregisterPushTokensRequest({
      tokenTypes: [pushNotificationTokenTypeRequestMap[tokenType]],
      deviceToken,
    });
  } catch (e) {
    logger.get('API').error('push.registerPushNotifications', e);
    throw buildModelError(e);
  }
};
